import { NodeViewRendererProps } from '@tiptap/core';

interface NodeAttributes {
  id: string;
  label?: string;
}

const AmountPlaceholder = ({ node }: NodeViewRendererProps) => {
  const { id, label } = node.attrs as NodeAttributes;
  const fallbackLabel = label ?? id;
  const finalLabel = id.includes(':') ? fallbackLabel.replace(/_/g, ' ') : fallbackLabel;

  return (
    <span data-node-view-wrapper="" className="mention">
      {finalLabel}
    </span>
  );
};

export default AmountPlaceholder;
